module.exports = __webpack_public_path__ + "img/bbc-radio-4.9f0b2592.png";